<script>
import { store } from './functions/mixins';
import * as sdk from './functions/sdk';
import UiAvatar from './components/ui/Avatar';
import UiInput from './components/ui/Input';
import UiSubheader from './components/ui/Subheader';
import UiButton from './components/ui/Button';
import UiLoading from './components/ui/Loading';
import UiContainer from './components/ui/Container';
import UiTabs from './components/ui/Tabs';
import cookies from 'browser-cookies';
import md5 from 'md5';
import UiModal from './components/ui/Modal';
import { TwoFactorAuthErrorString } from './functions/helpers';

export default {
    mixins: [store],
    components: {
        UiAvatar,
        UiInput,
        UiSubheader,
        UiButton,
        UiLoading,
        UiContainer,
        UiTabs,
        UiModal,
    },
    data() {
        return {
            sidebar: false,
            currentTab: 'api',
            enableFirebaseLogin: false,
            auth: {
                email: '',
                password: '',
                loading: false,
                error: false,
                timeout: false,
                ready: false,
            },
            testService: {
                modal: false,
                dontShowAgain: false,
            },
            twoFactorAuth: {
                modal: false,
                loading: false,
                error: false,
                code: '',
            },
        };
    },
    computed: {
        supportedLocales() {
            if (!this.userInfo) {
                return ['en'];
            } else {
                return this.userInfo.languages.split(',').map(i => i.trim());
            }
        },
        currentLocale() {
            return this.$i18n.locale;
        },
        isRouterViewAvaiable() {
            return this.isLogged || this.$route.meta.allowGuests;
        },
    },
    created() {
        if (location.search.indexOf('enableFirebaseLogin') > -1) {
            this.enableFirebaseLogin = true;
        }
        if (cookies.get('i18n')) {
            this.$i18n.locale = cookies.get('i18n');
        }
        sdk.setUnauthorizedExceptionFn(this.logout);
        sdk.pressengerControl.getUserInfo().then(uinfo => {
            this.setUserInfo(uinfo);
            this.sidebar = !!uinfo?.autoOpenSidebar;
            if (!this.supportedLocales.includes(this.currentLocale)) {
                this.setLocale(this.supportedLocales[0]);
            }
        }).catch(() => null).finally(() => {
            this.auth.ready = true;
        });
        setInterval(() => {
            if (this.isLogged) {
                sdk.pressengerControl.getUserInfo().then(uinfo => {
                    this.setUserInfo(uinfo);
                }).catch(() => {
                    this.logout();
                });
            }
        }, 60 * 1000);
        //this.chromeAutofilWorkaround();
        if (this.isInflugamers) {
            document.querySelector('html').style.background = '#242424';
        }
    },
    methods: {
        login() {
            sdk.setRecipientList(null);
            const elUser = document.querySelector('#login-form input[type=text]');
            const elPass = document.querySelector('#login-form input[type=password]');
            if (elUser && elPass && elUser.value.length && elPass.value.length) {
                this.auth.email = elUser.value;
                this.auth.password = elPass.value;
            }
            if (this.currentTab === 'api') {
                this.loginLegacy();
            } else {
                this.loginFirebase();
            }
        },
        loginLegacy() {
            sdk.setRecipientList(null);
            this.setUserInfo(null);
            this.auth.loading = true;
            this.auth.error = false;
            this.auth.timeout = false;
            sdk.accessManagement.loginEx(this.auth.email, this.auth.password).then(() => {
                sdk.pressengerControl.getUserInfo().then(uinfo => {
                    this.setUserInfo(uinfo);
                    this.sidebar = !!uinfo?.autoOpenSidebar;
                    if (!cookies.get('i18n')) {
                        this.setLocale(this.supportedLocales[0]);
                    }
                    this.auth.email = '';
                    this.auth.password = '';
                }).catch(() => {
                    this.auth.error = true;
                }).finally(() => {
                    this.auth.loading = false;
                });
            }).catch(error => {
                this.auth.loading = false;
                if (error === TwoFactorAuthErrorString) {
                    this.twoFactorAuth.modal = true;
                } else {
                    this.auth.error = true;
                }
            });
        },
        loginFirebase() {
            const { email, password } = this.auth;
            sdk.setRecipientList(null);
            this.setUserInfo(null);
            this.auth.loading = true;
            this.auth.error = false;
            this.auth.timeout = false;
            sdk.firebase.auth().signInWithEmailAndPassword(email, password).then(() => {
                sdk.firebase.auth().currentUser.getIdToken().then(faToken => {
                    sdk.accessManagement.loginWithFA(faToken).then(() => {
                        sdk.pressengerControl.getUserInfo().then(uinfo => {
                            this.setUserInfo(uinfo);
                            this.sidebar = !!uinfo?.autoOpenSidebar;
                            this.auth.loading = false;
                        }).catch(() => {
                            // cant get uinfo
                            this.auth.error = true;
                            this.auth.loading = false;
                        });
                    }).catch(() => {
                        // cant login on sdk
                        this.auth.error = true;
                        this.auth.loading = false;
                    });
                }).catch(() => {
                    // cant get token
                    this.auth.error = true;
                    this.auth.loading = false;
                });
            }).catch(() => {
                // cant signin
                this.auth.error = true;
                this.auth.loading = false;
            });
        },
        loginFirebaseFacebook() {
            sdk.setRecipientList(null);
            this.auth.loading = true;
            this.auth.error = false;
            this.auth.timeout = false;
            sdk.firebase.auth().signInWithPopup(sdk.fbFacebookProvider).then(() => {
                sdk.firebase.auth().currentUser.getIdToken().then(faToken => {
                    sdk.accessManagement.loginWithFA(faToken).then(() => {
                        sdk.pressengerControl.getUserInfo().then(uinfo => {
                            this.setUserInfo(uinfo);
                            this.sidebar = !!uinfo?.autoOpenSidebar;
                            this.auth.loading = false;
                        }).catch(() => {
                            // cant get uinfo
                            this.auth.error = true;
                            this.auth.loading = false;
                        });
                    }).catch(() => {
                        // cant login on sdk
                        this.auth.error = true;
                        this.auth.loading = false;
                    });
                }).catch(() => {
                    // cant get token
                    this.auth.error = true;
                    this.auth.loading = false;
                });
            }).catch(() => {
                this.auth.error = true;
                this.auth.loading = false;
            });
        },
        loginFirebaseGoogle() {
            sdk.setRecipientList(null);
            this.auth.loading = true;
            this.auth.error = false;
            this.auth.timeout = false;
            sdk.firebase.auth().signInWithPopup(sdk.fbGoogleProvider).then(() => {
                sdk.firebase.auth().currentUser.getIdToken().then(faToken => {
                    sdk.accessManagement.loginWithFA(faToken).then(() => {
                        sdk.pressengerControl.getUserInfo().then(uinfo => {
                            this.setUserInfo(uinfo);
                            this.sidebar = !!uinfo?.autoOpenSidebar;
                            this.auth.loading = false;
                        }).catch(() => {
                            // cant get uinfo
                            this.auth.error = true;
                            this.auth.loading = false;
                        });
                    }).catch(() => {
                        // cant login on sdk
                        this.auth.error = true;
                        this.auth.loading = false;
                    });
                }).catch(() => {
                    // cant get token
                    this.auth.error = true;
                    this.auth.loading = false;
                });
            }).catch(() => {
                this.auth.error = true;
                this.auth.loading = false;
            });
        },
        clearLoginErrors() {
            this.auth.error = false;
            this.auth.timeout = false;
        },
        setLocale(locale) {
            if (this.supportedLocales.includes(locale)) {
                sdk.pressengerControl.setLocale(locale).then(() => {
                    this.$i18n.locale = locale;
                    cookies.set('i18n', locale);
                });
            }
        },
        firebaseLogged(faToken) {
            sdk.accessManagement.loginWithFA(faToken).then(() => {
                sdk.pressengerControl.getUserInfo().then(uinfo => {
                    this.setUserInfo(uinfo);
                    this.sidebar = !!uinfo?.autoOpenSidebar;
                }).catch(() => {
                    this.auth.error = true;
                });
            }).catch(() => {
                this.auth.error = true;
            });
        },
        isSVG(filename) {
            return filename.split('.').pop().toLowerCase() === 'svg';
        },
        showTestServiceModal() {
            if (this.userInfo && this.userInfo.trial && cookies.get('testServiceModal') !== 'hide') {
                this.testService.modal = true;
            }
        },
        closeTestServiceModal(goToProfile) {
            this.testService.modal = false;
            if (this.testService.dontShowAgain) {
                const expiryDate = new Date(8640000000000000);
                cookies.set('testServiceModal', 'hide', {
                    expires: 365,
                });
            }
            if (goToProfile) {
                this.$router.push({name: 'settings'});
            }
        },
        loginTwoFactorAuth() {
            sdk.setRecipientList(null);
            this.setUserInfo(null);
            this.auth.timeout = false;
            this.twoFactorAuth.loading = true;
            this.twoFactorAuth.error = false;
            sdk.accessManagement.loginWithGA(this.auth.email, this.auth.password, this.twoFactorAuth.code).then(() => {
                sdk.pressengerControl.getUserInfo().then(uinfo => {
                    this.setUserInfo(uinfo);
                    this.sidebar = !!uinfo?.autoOpenSidebar;
                    if (!cookies.get('i18n')) {
                        this.setLocale(this.supportedLocales[0]);
                    }
                    this.auth.email = '';
                    this.auth.password = '';
                    this.twoFactorAuth.modal = false;
                    this.twoFactorAuth.code = '';
                }).catch(() => {
                    this.twoFactorAuth.error = true;
                }).finally(() => {
                    this.twoFactorAuth.loading = false;
                });
            }).catch(error => {
                this.twoFactorAuth.error = true;
                this.twoFactorAuth.loading = false;
            });
        },
    },
    onIdle() {
        if (this.isLogged && !this.isPushwize()) {
            const email = this.userInfo.name;
            this.logout().finally(() => {
                this.auth.email = email;
                this.auth.timeout = true;
            });
        }
    },
    watch: {
        isRouterViewAvaiable(nextValue) {
            if (nextValue) {
                sdk.pressengerControl.getCustomMenu().then(modules => {
                    this.setCustomMods(modules);
                });
                setTimeout(() => {
                    if (!this.isPushwize) {
                        this.showTestServiceModal();
                    }
                });
            } else {
                this.setCustomMods([]);
            }
        },
    }
}
</script>

<template>
    <div
        :class="{
            AppRoot: true,
            AppPushwizeColors: isPushwize,
            AppFinestratColors: isFinestrat,
            AppInflugamersColors: isInflugamers,
        }"
    >
        <template v-if="requestedMode === null">
            <div v-if="!isLogged" class="RouterWorkaround"></div>
            <div class="AppHeader">
                <a href="javascript:;" class="Hamburger" @click="sidebar = !sidebar">
                    <span :class="{SmartIcon: true, Open: sidebar}">
                        <span class="Bar"></span>
                        <span class="Bar"></span>
                        <span class="Bar"></span>
                    </span>
                </a>
                <a href="/" class="Logo">
                    <img :src="isFinestrat ? '/static/img/finestrat_logo.png' : '/static/img/logo.png'" />
                </a>
                <span class="Spacer"></span>
                <template v-if="supportedLocales.length > 1">
                    <a href="javascript:;" class="Lang">
                        {{ currentLocale }}
                        <div class="LangList">
                            <a
                                href="javascript:;"
                                v-for="(i, key) in supportedLocales"
                                @click="setLocale(i)"
                                :key="key"
                            >{{ i  }}</a>
                        </div>
                    </a>
                </template>
                <template v-if="isLogged">
                    <a href="javascript:;" class="UserMenu" @click="logout()">
                        <span class="DisplayName">{{ userInfo.userName }}</span>
                        <ui-avatar :username="userInfo.userName"></ui-avatar>
                        <div class="LogoutOverlay">{{ $t('app.logout') }}</div>
                    </a>
                </template>
            </div>
            <div v-if="sidebar" @click="sidebar = false" class="AppSidebarOverlay"></div>
            <div :class="{AppSidebar: true, Expanded: sidebar}" ref="sidebar">
                <router-link :to="{name: 'send'}" v-if="!userInfo || (userInfo && !userInfo.hideToolbox && enabledSysMenus.includes('toolbox'))">
                    {{ $t('app.menuSend') }}
                    <span class="LinkIcon" :title="$t('app.menuSend')">
                        <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M29.35 9l-2.22-1a5.73 5.73 0 00-2.35-.5h-2.31v-.89a2.59 2.59 0 00-.92-2 2 2 0 00-2.55.08l-.14.16a2 2 0 00-.2-.21 2 2 0 00-2.56.05l-.1.15-.2-.2a2 2 0 00-2.56.05 1 1 0 00-.14.15l-.2-.2a2 2 0 00-2.57.05 2.72 2.72 0 00-.92 2v.78H2.48a1.61 1.61 0 00-1.6 1.6v2.42a1.6 1.6 0 001.6 1.6h4.3v3.09c0 .12-.21 2.8 3.23 4.36v5.53a.75.75 0 001.5 0v-6a.75.75 0 00-.48-.7c-2.84-1.1-2.76-3-2.76-3.1v-3.18H9.4a.74.74 0 001.46-.19V6.68a1.28 1.28 0 01.44-.89.4.4 0 01.58 0 1.1 1.1 0 01.38.83v6.28a.75.75 0 001.5 0V6.68a1.28 1.28 0 01.44-.89.4.4 0 01.58 0 1.08 1.08 0 01.39.83v6.28a.75.75 0 101.5 0V6.68a1.24 1.24 0 01.44-.89.38.38 0 01.57 0 1.08 1.08 0 01.39.83v6.28a.75.75 0 001.5 0V6.68a1.24 1.24 0 01.43-.89.38.38 0 01.57 0 1.08 1.08 0 01.39.83v6.98c0 1.06-.13 4.62-1.8 5.77a.72.72 0 00-.33.61v6.14a.75.75 0 001.5 0V20.3c1.85-1.58 2.13-4.87 2.13-6.75v-.46h2.05a5.69 5.69 0 002.62-.63l2.27-1.16a1.3 1.3 0 00-.05-2.3zM7.53 11.59H5.44V9h3.92v2.63zm-5.15-.1V9.07a.1.1 0 01.1-.07h1.46v2.63H2.48a.09.09 0 01-.1-.14zm20.09.1V9h2.29v2.62h-2.29zm4-.46l-.21.09v-2l.26.08 1.84.83z"/></svg>
                    </span>
                </router-link>
                <router-link :to="{name: 'sendModNews', query: {modNews: 1}}" v-if="isModNewsEnabled">
                    {{ $t('app.menuSendModNews') }}
                    <span class="LinkIcon" :title="$t('app.menuSendModNews')">
                        <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M4.11 28.93H4a3.19 3.19 0 01-3-3.15V12.69v-5.2A2.1 2.1 0 011.58 6a2.17 2.17 0 011.54-.64h3.35a.75.75 0 010 1.5H3.12a.67.67 0 00-.48.2.63.63 0 00-.19.47V25.8A1.66 1.66 0 005.26 27a1.69 1.69 0 00.53-1.25v-3.6a.75.75 0 011.5 0v3.6A3.23 3.23 0 016.3 28a3.12 3.12 0 01-2.19.93z"/><path d="M6.54 19.85a.75.75 0 01-.75-.75V3.79A2.17 2.17 0 018 1.62h20.22a2.17 2.17 0 012.17 2.17V14a.75.75 0 01-1.5 0V3.79a.67.67 0 00-.67-.67H8a.68.68 0 00-.67.67V19.1a.74.74 0 01-.79.75zM26.76 29H4.51a.75.75 0 010-1.5h22.25a2.13 2.13 0 002.13-2.13V17a.75.75 0 011.5 0v8.32A3.64 3.64 0 0126.76 29z"/><path d="M25.91 20.41H10.39a.75.75 0 010-1.5h15.52a.75.75 0 010 1.5zM25.91 24.76H10.39a.75.75 0 010-1.5h15.52a.75.75 0 010 1.5zM25.91 11.84H20a.75.75 0 010-1.5h5.89a.75.75 0 010 1.5zM25.91 7.58H20a.75.75 0 010-1.5h5.89a.75.75 0 010 1.5zM25.91 16.06H10.39a.75.75 0 110-1.5h15.52a.75.75 0 110 1.5zM15.5 11.93h-3.74a2.18 2.18 0 01-2.18-2.17v-1.5a2.19 2.19 0 012.18-2.18h3.74a2.19 2.19 0 012.18 2.18v1.5a2.18 2.18 0 01-2.18 2.17zm-3.74-4.35a.69.69 0 00-.68.68v1.5a.68.68 0 00.68.67h3.74a.67.67 0 00.68-.67v-1.5a.68.68 0 00-.68-.68z"/></svg>
                    </span>
                </router-link>
                <div v-for="i in customMods" :key="i.id">
                    <router-link :to="{name: 'module', params: {id: i.id}}" v-if="!i.external">
                        {{ i.title || 'Unnamed Module' }}
                        <span class="LinkIcon" :title="i.title">
                            <span v-if="i.icon.indexOf('<svg') === 0" v-html="i.icon"></span>
                            <img v-else :src="i.icon" alt="" />
                        </span>
                    </router-link>
                    <router-link :to="{name: 'module-redirect', params: {id: i.id}}" target="_blank"  v-else>
                        {{ i.title || 'Unnamed Module' }}
                        <span class="LinkIcon" :title="i.title">
                            <span v-if="i.icon.indexOf('<svg') === 0" v-html="i.icon"></span>
                            <img v-else :src="i.icon" alt="" />
                        </span>
                    </router-link>
                </div>
                <router-link :to="{name: 'perfomance'}" v-if="!userInfo || (!userInfo.hideStat && enabledSysMenus.includes('performance'))">
                    {{ $t('app.menuPerfomance') }}
                    <span class="LinkIcon" :title="$t('app.menuPerfomance')">
                        <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="31" height="31" viewBox="0 0 31 31" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M21.27 1.5v6.59h-6.59v6.59H8.09v6.589H1.5V29.5h28v-28h-8.23zM8.09 27.859H3.141V22.91H8.09v4.949zm6.59 0H9.73V16.32h4.95v11.539zm6.59 0h-4.95V9.73h4.95v18.129zm6.589 0H22.91v-1.654h4.949v1.654zm0-3.295H22.91V22.91h4.949v1.654zm0-3.295H22.91v-1.654h4.949v1.654zm0-3.294H22.91V16.32h4.949v1.655zm0-3.295H22.91v-1.655h4.949v1.655zm0-3.295H22.91V9.73h4.949v1.655zm0-3.295H22.91V6.435h4.949V8.09zm0-3.295H22.91V3.141h4.949v1.654z"/></svg>
                    </span>
                </router-link>
                <router-link :to="{name: 'settings'}" v-if="!userInfo || enabledSysMenus.includes('profile')">
                    {{ $t('app.menuSettings') }}
                    <span class="LinkIcon" :title="$t('app.menuSettings')">
                        <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="30" height="34" viewBox="0 0 30 34" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M1.5 32.5v-.908c0-5.242 4.226-9.506 9.42-9.506h8.16c5.194 0 9.42 4.264 9.42 9.506v.908h-27zm10.45-8.598c.39 1.329 1.609 2.301 3.05 2.301 1.441 0 2.66-.972 3.049-2.301H11.95zm7.939.044c-.442 2.317-2.466 4.074-4.889 4.074s-4.447-1.757-4.889-4.074c-3.527.377-6.343 3.191-6.758 6.737h23.294c-.415-3.546-3.231-6.36-6.758-6.737zM15 20.269c-4.632 0-8.4-3.802-8.4-8.476V9.977C6.6 5.303 10.368 1.5 15 1.5c4.632 0 8.4 3.803 8.4 8.477v1.816c0 4.674-3.768 8.476-8.4 8.476zm6.6-10.292c0-3.673-2.961-6.661-6.6-6.661S8.4 6.304 8.4 9.977v1.816c0 3.672 2.961 6.66 6.6 6.66s6.6-2.988 6.6-6.66V9.977zm-5.4-.909h3v1.817h-3V9.068zm-5.4 0h3v1.817h-3V9.068z"/></svg>
                    </span>
                </router-link>
                <router-link :to="{name: 'media'}" v-if="!userInfo || (!isEditorAccount && enabledSysMenus.includes('gallery'))">
                    {{ $t('app.menuMedia') }}
                    <span class="LinkIcon" :title="$t('app.menuMedia')">
                        <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="31" height="31" viewBox="0 0 31 31" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M28.542 8.259a3.258 3.258 0 00.958-2.32c0-.879-.34-1.703-.958-2.321l-1.16-1.16a3.259 3.259 0 00-2.321-.958c-.878 0-1.702.34-2.32.958L15.499 9.7 7.307 1.508 1.506 7.309l8.192 8.192-6.264 6.264L1.5 29.5l7.735-1.934 6.264-6.264 8.192 8.192 5.801-5.801-8.192-8.192 7.242-7.242zm-4.641-4.641c.308-.308.72-.477 1.16-.477.44 0 .852.169 1.161.477l1.16 1.16c.308.308.477.721.477 1.161 0 .44-.169.852-.477 1.16l-.58.58-3.481-3.481.58-.58zm-1.74 1.741l3.48 3.48-1.16 1.16-3.48-3.48 1.16-1.16zM3.826 7.309l3.481-3.48 1.57 1.57-1.16 1.16 1.16 1.16 1.161-1.16 1.57 1.571-1.16 1.16 1.16 1.16 1.16-1.16 1.571 1.57-3.481 3.481-7.032-7.032zm16.014.37l1.161 1.16L6.495 23.345l-1.16-1.16L19.84 7.679zM3.755 27.245l.864-3.456 2.591 2.592-3.455.864zm5.06-1.58l-1.16-1.16L22.161 9.999l1.16 1.161L8.815 25.665zm12.895-7.433l-1.16 1.16 1.16 1.16 1.16-1.16 1.571 1.57-1.16 1.161 1.16 1.16 1.16-1.16 1.57 1.57-3.48 3.481-7.032-7.032 3.481-3.481 1.57 1.571z"/></svg>
                    </span>
                </router-link>
            </div>
        </template>
        <div v-else-if="requestedMode === 'pushwizeToolbar'" class="AppHeaderPushwize">
            <a href="javascript:;" @click="$router.push({name: 'send', query: {requestedMode: 'pushwizeToolbar'}})" :class="{active: $route.name === 'send'}">Toolbox</a>
            <a href="javascript:;" @click="$router.push({name: 'module', params: {id: 'ba5e2096-0129-463a-8a62-6592dc0dd7b0'}, query: {requestedMode: 'pushwizeToolbar'}})" :class="{active: $route.name === 'module'}">News</a>
        </div>
        <div
            :class="{
                AppContent: true,
                AppContentFull: ['pushwize', 'influgamers'].includes(requestedMode),
                AppContentAlmostFull: ['pushwizeToolbar'].includes(requestedMode),
            }"
        >
            <router-view v-if="isRouterViewAvaiable" />
            <div v-else-if="auth.ready" class="LoginWrapper">
                <div :class="{LoginWidget: true, Error: auth.error, Loading: auth.loading}">
                    <ui-tabs
                        v-model="currentTab"
                        v-if="enableFirebaseLogin"
                        :tabs="[
                            {title: $t('app.tabApi'), value: 'api'},
                            {title: $t('app.tabFirebase'), value: 'firebase'},
                        ]"
                    />
                    <form @submit.prevent="login()" id="login-form">
                        <div class="LoginInner">
                            <div class="Timeout" v-if="auth.timeout">
                                {{ $t('app.timeoutWarning') }}
                            </div>
                            <ui-input
                                v-model="auth.email"
                                :label="$t('app.email')"
                                :readonly="auth.loading"
                                @keydown.native="clearLoginErrors()"
                            />
                            <ui-input
                                v-model="auth.password"
                                :label="$t('app.password')"
                                type="password"
                                :readonly="auth.loading"
                                @keydown.native="clearLoginErrors()"
                            />
                            <div class="LoadingOverlay">
                                <ui-loading />
                            </div>
                        </div>
                        <div class="AddSpace">
                            <ui-button :disabled="auth.loading">{{ $t('app.login') }}</ui-button>
                            <template v-if="currentTab === 'firebase'">
                                <ui-button @click.native="loginFirebaseFacebook()" :disabled="auth.loading" :submit="false" type="secondary">
                                    {{ $t('app.loginFacebook') }}
                                </ui-button>
                                <ui-button @click.native="loginFirebaseGoogle()" :disabled="auth.loading" :submit="false" type="secondary">
                                    {{ $t('app.loginGoogle') }}
                                </ui-button>
                            </template>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <ui-modal :visible="testService.modal" class="text-center text-primary">
            <div class="font-bold mb-3" v-html="$t('app.testServiceModalBody')" />
            <div class="FlexRow JustifyCenter mb-3">
                <ui-button @click.native="closeTestServiceModal(true)" class="secondary mr-1">{{ $t('app.testServiceModalOk') }}</ui-button>
                <ui-button @click.native="closeTestServiceModal(false)" class="secondary ml-1">{{ $t('app.testServiceModalCancel') }}</ui-button>
            </div>
            <div>
                <label class="FlexRowInline AlignCenter font-bold">
                    <input type="checkbox" v-model="testService.dontShowAgain" />
                    {{ $t('app.testServiceModalDontShowAgain') }}
                </label>
            </div>
            <div>{{ $t('app.testServiceModalInfo') }}</div>
        </ui-modal>
        <ui-modal :visible="twoFactorAuth.modal">
            <h4 class="mt-0">{{ $t('app.twoFactorAuthTitle') }}</h4>
            <div class="mb-3">
                <form @submit.prevent="loginTwoFactorAuth()">
                    <ui-input
                        v-model="twoFactorAuth.code"
                        :label="$t('app.twoFactorAuthCodeLabel')"
                        :disabled="twoFactorAuth.loading"
                        :error="twoFactorAuth.error"
                        class="StyleAlt02"
                    />
                </form>
            </div>
            <div class="FlexRow JustifyEnd">
                <ui-button
                    @click.native="loginTwoFactorAuth()"
                    :disabled="twoFactorAuth.loading"
                    class="secondary mr-1"
                >{{ $t('app.twoFactorAuthOk') }}</ui-button>
                <ui-button
                    @click.native="twoFactorAuth.modal = false"
                    :disabled="twoFactorAuth.loading"
                    class="secondary ml-1"
                >{{ $t('app.twoFactorAuthCancel') }}</ui-button>
            </div>
        </ui-modal>
    </div>
</template>

<style lang="stylus">
@import './stylus/v2'
@import './stylus/pushwize'
@import './stylus/finestrat'
@import './stylus/influgamers'

.RouterWorkaround
    position fixed
    top 0
    bottom 0
    left 0
    width 100px
    z-index 100
</style>
